<template>
	<div>
		<div class="form-icon-input">
			<div>
				<Icon icon="search"/>
			</div>
			<div>
				<b-input
					v-model="text"
					ref="text"
					:placeholder="placeholder"
					@input="onValueChanged"
				/>
			</div>
			<div v-if="hasText">
				<a href="#" @click.prevent="resetText">
					<Icon icon="close"/>
				</a>
			</div>
		</div>
		<div v-if="catalogInfo" class="mt-2">
			<JonInfo>
				<template #message>
					<span v-html="catalogInfo"/>
				</template>
			</JonInfo>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import {isEmptyOrNull, removeParagraphs} from "@/helper/String";
import _, {debounce} from "lodash";
import EventData from "@/helper/tracking/EventData";
import * as Event from "@/helper/tracking/Event";
import JonInfo from "@/vue/common/JonInfo.vue";

export default {

	components: {
		JonInfo,
		Icon,
	},

	props: {
		value: {
			type: String,
			required: false,
		},
		placeholder: {
			type: String,
			required: false,
		},
		characteristicType: {
			type: Object,
			required: false,
		},
		catalog: {
			type: Array,
			required: false
		}
	},

	data ()
	{
		return {
			text: this.value || '',
		};
	},

	computed: {
		catalogInfo ()
		{
			if (!this.catalog || isEmptyOrNull(this.text))
			{
				return undefined;
			}

			const item = _.find(
				this.catalog,
				characteristic => characteristic.label.toLowerCase() === this.text.toLowerCase()
			);

			return item?.description
				? removeParagraphs(item?.description)
				: undefined;
		},
		hasText ()
		{
			return !isEmptyOrNull(this.text);
		},
	},

	methods: {
		log: debounce((text, characteristicType) =>
		{
			let action = 'Suche';

			if (characteristicType)
			{
				action += ' (' + characteristicType.label + ')';
			}

			Event.push(
				new EventData()
					.setEvent(Event.TAG_SEARCH)
					.setAction(action)
					.setName(text)
			);

		}, 1000),
		onValueChanged ()
		{
			this.log(this.text, this.characteristicType);

			this.emitChangeEvent();
		},
		resetText ()
		{
			this.text = '';

			this.$nextTick(() =>
			{
				this.$refs.text.focus();
			});

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			this.$emit('input', this.text);
		}
	},

	watch: {
		value (v)
		{
			this.text = v;
		}
	}
}
</script>
